<template>
    <div>
        <div>
            <div class="flex" :class="wMobile ? 'flex-col' : ''">
                <div :class="wMobile ? '' : 'w-1/4'">
                    <span class="block text-center text-2xl font-bold mb-8">{{
                        $t("directions_for_training")
                    }}</span>
                    <form data-vv-scope="direction">
                        <vs-card>
                            <h4 class="ml-2">{{ $t("filters") }}</h4>
                            <div class="-mt-2">
                                <div :class="classForDOM.block" class="">
                                    <MultiselectCustom
                                        endpoint="admissions/study-forms-for-directions/"
                                        @selected="getListDirections"
                                        name="study_form"
                                        :placeholder="`${$t('study_form')}`"
                                        v-model="
                                            dataForGetDirections.study_form
                                        "
                                    />
                                </div>
                            </div>
                            <div>
                                <div :class="classForDOM.block" class="">
                                    <MultiselectCustom
                                        endpoint="organizations/languages/"
                                        name="language"
                                        @selected="getListDirections"
                                        :placeholder="`${$t('language')}`"
                                        v-model="dataForGetDirections.language"
                                    />
                                </div>
                            </div>
                            <div>
                                <div :class="classForDOM.block" class="">
                                    <MultiselectCustom
                                        endpoint="organizations/edu-program-groups/"
                                        name="education_program_group"
                                        @selected="getListDirections"
                                        :placeholder="`${$t('groupOp')}`"
                                        v-model="
                                            dataForGetDirections.education_program_group
                                        "
                                    />
                                </div>
                            </div>
                            <div>
                                <div :class="classForDOM.block" class="">
                                    <MultiselectCustom
                                        endpoint="admissions/education-programs-for-directions/"
                                        name="education_program_name"
                                        :param="{
                                            group:
                                                dataForGetDirections.education_program_group,
                                            preparation_level: this
                                                .preparation_level,
                                        }"
                                        @selected="getListDirections"
                                        :placeholder="`${$t('edu_prog')}`"
                                        v-model="
                                            dataForGetDirections.education_program
                                        "
                                    />
                                </div>
                            </div>
                            <div>
                                <div :class="classForDOM.block" class="">
                                    <MultiselectCustom
                                        endpoint="organizations/edu-bases/"
                                        name="admission_basis"
                                        @selected="getListDirections"
                                        :placeholder="`${$t(
                                            'admission_basis'
                                        )}`"
                                        v-model="
                                            dataForGetDirections.admission_basis
                                        "
                                    />
                                </div>
                            </div>
                            <div v-if="fullData.grant">
                                <div :class="classForDOM.block" class="mt-2">
                                    <vs-button
                                        type="relief"
                                        @click="getDirectionsFromGrant"
                                    >
                                        {{ $t("getDirectionsFromGrant") }}
                                    </vs-button>
                                </div>
                            </div>
                        </vs-card>
                    </form>
                    <vs-divider></vs-divider>
                    <vs-button
                        @click="clearFilters"
                        class="w-full mb-2"
                        color="warning"
                        >{{ $t("show_all") }}</vs-button
                    >
                </div>

                <div :class="wMobile ? '' : 'ml-4'" class="w-full">
                    <div>
                        <span
                            class="block text-center text-xl font-bold mb-8"
                            >{{ $t("selected_directions") }}</span
                        >
                        <div
                            :class="classForDOM.parent"
                            v-if="!directions.length"
                        >
                            <span class="text-danger text-sm mb-4">
                                {{ $t("directions_required_text") }}
                            </span>
                        </div>

                        <template v-if="directions.length">
                            <vs-card
                                v-for="direction in directions"
                                :key="direction.uid"
                            >
                                <div
                                    :class="wMobile ? 'flex-col' : ''"
                                    class="flex items-center justify-between"
                                >
                                    <!-- <span
                                        class="text-lg font-bold block mr-6 ml-4"
                                    >
                                        {{ `#${direction.order_number + 1}` }}
                                    </span> -->
                                    <DirectionForRender
                                        style="width: 100%"
                                        :data="direction"
                                    />
                                    <vs-button
                                        v-if="!disabled"
                                        class="ml-4 mr-4"
                                        style="min-width: 4.1%"
                                        color="danger"
                                        @click="removeDirection(direction)"
                                        type="relief"
                                        icon="delete"
                                    >
                                    </vs-button>
                                </div>
                            </vs-card>
                        </template>
                    </div>
                    <div class="flex items-center">
                        <vs-input
                            v-model="search"
                            :placeholder="$t('search')"
                            class="w-full mb-4"
                        ></vs-input>
                        <vs-button
                            @click="find"
                            class="ml-2 -mt-4"
                            icon="search"
                            >{{ $t("find") }}</vs-button
                        >
                    </div>
                    <div
                       v-if="listDirections && listDirections.length"
                        class="mt-8"
                    >
                        <span
                            class="text-xl font-semibold block text-center mb-8 mt-4"
                        >
                            {{ $t("title_list_directions") }}
                        </span>
                        <vs-card
                            v-for="direction in listDirections"
                            v-if="!direction.unused"
                            :key="direction.uid"
                        >
                            <div
                                :class="wMobile ? 'flex-col' : ''"
                                class="flex items-center justify-between"
                            >
                                <DirectionForRender
                                    style="width: 100%"
                                    :data="direction"
                                />

                                <vs-button
                                    color="success"
                                    @click="addDirection(direction)"
                                    class="ml-4 mr-4"
                                    style="min-width: 4.1%"
                                    icon="add"
                                    type="relief"
                                >
                                </vs-button>
                            </div>
                        </vs-card>
<!--                        <vs-pagination-->
<!--                            :total="pageCount"-->
<!--                            v-model="page"-->

<!--                        ></vs-pagination>-->
                        <!-- <infinite-loading
                            @infinite="infiniteHandler"
                        ></infinite-loading> -->
                    </div>
                    <div v-else>
                        <span class="text-base font-semibold">{{
                            $t("list_empty")
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DirectionForRender from "@/pages/Home/FillingInTheApplicantsData/Declaration/components/DirectionForRender";
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";

export default {
    name: "DirectionOfTraining",
    components: {
        DirectionForRender,
        MultiselectCustom,
        ValidateText,
    },
    props: {
        data: {
            type: Object,
            require: true,
        },
        file_upload_limitation: {
            type: Object,
            require: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        wMobile() {
            return window.innerWidth < 800;
        },
        listSelectedDirections() {
            return this.directions;
        },
        order_number() {
            return this.directions.length;
        },
        campaign() {
            return this.data["campaign"];
        },
        preparation_level() {
            return this.data["preparation_level"];
        },
        preparation_level_name() {
            return this.data["preparation_level_data"]["name"];
        },
        based_on_name() {
            return this.data["based_on"] ? this.data["based_on"]["name"] : null;
        },
        based_on() {
            return this.data["based_on"] ? this.data["based_on"]["uid"] : null;
        },
        study_year() {
            return this.data["study_year"];
        },
        dataObject() {
            return this.objectForEditDirection;
        },
        fullData() {
            return this.data;
        },
        profileUid() {
            return this.data.profile.uid;
        },
        pageCount() {
            let l = this.listDirections.length,
                s = this.size;

            return Math.ceil(l / s) - 1;
        },
        paginatedData() {
            const start = (this.page * this.size),
                end = (start + this.size);

            return this.listDirections.slice(start, end);
        },
    },
    data() {
        return {
            direction: {
                plan: "",
                profile: this.data.profile.uid,
            },
            size: 15,
            directions: [],
            copyListDirections: [],
            objectSelectedDirection: null,
            dataForGetDirections: {
                //campaign: this.campaign,
                //preparation_level: this.preparation_level,
                //based_on: this.based_on,
                //study_period__start: this.study_year,
                study_form: "",
                language: "",
                education_program_group: "",
                education_program: "",
                admission_basis: "",
            },
            listDirections: null,
            page: 1,
            search: "",

            statusModalAddDirection: false,
            objectForEditDirection: null,
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
            temp_directions: [],
        };
    },
    methods: {
        find() {
            this.listDirections = this.copyListDirections.filter((item) => {
                return item["education_program_name"]
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
            });


        },
        clearFilters() {
            this.dataForGetDirections = {
                //campaign: this.campaign,
                //preparation_level: this.preparation_level,
                //based_on: this.based_on,
                //study_period__start: this.study_year,
                study_form: "",
                language: "",
                education_program_group: "",
                education_program: "",
                admission_basis: "",
            };
            //this.listDirections = null;
            this.search = "";
            this.getListDirections()
        },
        async getFullData() {
            try {
                this.$vs.loading();
                const response = (
                    await this.$http.get("admissions/applicants/data/", {
                        params: {
                            profile: this.data.profile.uid,
                        },
                    })
                ).data;

                this.directions = response.directions;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        showModalDirection() {
            this.statusModalAddDirection = true;
        },
        closeModalDirection() {
            this.statusModalAddDirection = false;
        },
        setObjectDirection(object) {

            this.directions.push(object);

            this.closeModalDirection();
        },
        async removeDirection(object) {
            try {
                this.$vs.loading();

                const response = (
                    await this.$http.delete(
                        `admissions/directions/${ object.uid }/`
                    )
                ).data;

                // Удаление направления из личного списка
                this.removeDirectionFromTemp(object);

                this.directions = this.directions.filter(
                    (d) => d.uid !== object.uid
                );
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        async movingDirection(type, object) {
            try {
                this.$vs.loading();

                let order = object.order_number;

                if (type === "up") {
                    order = order - 1;
                } else if (type === "down") {
                    order = order + 1;
                }

                this.directions = (
                    await this.$http.patch(
                        `admissions/directions/${ object.uid }/`,
                        {
                            order_number: order,
                        }
                    )
                ).data;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        validateStep() {
            if (this.data.education.files.length <= 0) {
                this.$vs.notify({
                    text: this.$t("upload_the_required_documents"),
                    color: "danger",
                });
                return false
            } else {
                if (!this.disabled) {
                    if (this.directions.length) {
                        this.$emit("setNewDataInObject", {
                            name: "directions",
                            data: this.directions,
                        });
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }
        },

        async getDirectionsFromGrant() {
            try {
                this.$vs.loading();

                this.listDirections = (
                    await this.$http.get(
                        "admissions/recruitment-plans/budget-directions/",
                        {
                            params: {
                                applicant: this.fullData.uid,
                            },
                        }
                    )
                ).data;

                this.page = false;

                // Очистка селектов
                this.dataForGetDirections.study_form = "";
                this.dataForGetDirections.language = "";
                this.dataForGetDirections.education_program_group = "";
                this.dataForGetDirections.education_program = "";
                this.dataForGetDirections.admission_basis = "";
            } catch (e) {
                this.$vs.notify({
                    title: "Danger",
                    text: this.$t("not_directions_in_your_grant"),
                    color: "danger",
                });
            } finally {
                this.$vs.loading.close();
            }
        },
        async saveDirection() {
            return this.$validator
                .validateAll("direction")
                .then(async (result) => {
                    if (result && this.objectSelectedDirection) {
                        try {
                            this.$vs.loading();

                            const response = (
                                await this.$http.post(
                                    "admissions/directions/",
                                    this.direction
                                )
                            ).data;

                            //await this.setObjectDirection(response)

                            // Получить список собственных направлений
                            await this.getOwnDirections()


                        } catch (e) {
                            this.$vs.notify({
                                title: this.$t("error"),
                                text: e.error,
                                color: "danger",
                            });
                        } finally {
                            this.$vs.loading.close();
                        }

                        return true;

                    } else {
                        return false;
                    }


                });
        },
        async getListDirections() {
            try {
                this.$vs.loading();

                let response = (
                    await this.$http.get("admissions/recruitment-plans/", {
                        params: {
                            ...this.dataForGetDirections,
                            applicant: this.$store.state.user.user.role['edit_moderator'] || this.$store.state.user.user.role['is_mod'] ? this.direction.profile : null,
                        },
                    })
                ).data;

                response = await response.filter((recruitment_plan) => {
                    return !this.listSelectedDirections.some((direction) => {
                        return (
                            direction.plan === recruitment_plan.uid ||
                            (!this.fullData.grant &&
                                recruitment_plan["admission_basis_code"] ===
                                    "budget")
                        );
                    });
                });

                // if (!response.next) {
                //     this.page = false;
                // }

                this.listDirections = response;
                this.copyListDirections = response;

                // нумеруем все направления для индексации
                this.numerateListDirections();
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        // async infiniteHandler($state) {
        //     if (this.page) {
        //         try {
        //             this.$vs.loading();
        //
        //             let response = (
        //                 await this.$http.get("admissions/recruitment-plans/", {
        //                     params: {
        //                         ...this.dataForGetDirections,
        //                         page: this.page,
        //                     },
        //                 })
        //             ).data;
        //
        //             response.results = await response.results.filter(
        //                 (recruitment_plan) => {
        //                     return !this.listSelectedDirections.some(
        //                         (direction) => {
        //                             return (
        //                                 direction.plan ===
        //                                     recruitment_plan.uid ||
        //                                 (!this.fullData.grant &&
        //                                     recruitment_plan[
        //                                         "admission_basis_code"
        //                                     ] === "budget")
        //                             );
        //                         }
        //                     );
        //                 }
        //             );
        //
        //             if (!response.next) {
        //                 this.page = false;
        //             } else {
        //                 this.page = this.page + 1;
        //             }
        //
        //             if (response.length) {
        //                 await response.forEach((direction) => {
        //                     this.listDirections.push(direction);
        //                 });
        //             }
        //
        //             $state.loaded();
        //         } catch (e) {
        //         } finally {
        //             this.$vs.loading.close();
        //         }
        //     } else {
        //         $state.complete();
        //     }
        // },
        addDirection(object) {
            this.objectSelectedDirection = object;
            this.direction.plan = object.plan ? object.plan : object.uid;
            this.saveDirection();
        },
        // Проблема была в том что если мы удаляем выбранное направление,
        // то оно вставлялось в конец списка направлений, что было неудобно для пользователя,
        // я реализовал 2 списка и алгоритмы добавления и удаления направлений между этими списками
        //
        // При возникновении непоняток и ошибок можно закоментировать мои функции и раскоментить функцию setObjectDirection()
        async getOwnDirections() {
            try {
                this.$vs.loading();

                this.directions = (
                    await this.$http.get(
                        "admissions/directions/",
                        {params: { profile: this.direction.profile }}
                    )
                ).data;

                // разделяем списки направлений если есть личные направления
                await this.separate_directions();
            } catch (e) {
                this.$vs.notify({
                    title: this.$t("error"),
                    text: e.error,
                    color: "danger",
                });
            } finally {
                this.$vs.loading.close();
            }
        },
        // Алгоритм удаления направления из основного списка и добавления его в кэш
        separate_directions() {
            this.temp_directions = [];
            let iterator = this.listDirections.keys();
            for (let key of iterator) {
                // для каждого key, обходим каждое направление,
                // временная сложность не будет большой т.к. на кол-во направлений есть лимит(max = около 5)
                this.directions.forEach((own_direction) => {
                    // если это не первое сохранение то json менялся и нам нужен уже не uid а plan
                    let direction_uid = this.listDirections[key].plan ? this.listDirections[key].plan : this.listDirections[key].uid;
                    let own_direction_uid = own_direction.plan ? own_direction.plan : own_direction.uid;
                    if (direction_uid === own_direction_uid) {
                        this.temp_directions.push(this.listDirections[key]);
                        own_direction.order = key;
                        this.listDirections[key]['unused'] = true;
                    }
                })
            }
        },
        // Алгоритм удаления направления из кеша и его добавление в основной список
        removeDirectionFromTemp(object) {
            let iterator = this.temp_directions.keys();
            for (let key of iterator) {
                // если это не первое сохранение то json менялся и нам нужен уже plan а не uid
                let secondary_saved_direction = this.temp_directions[key].plan ? this.temp_directions[key].plan : this.temp_directions[key].uid;
                if (secondary_saved_direction === object.plan) {
                    this.listDirections[this.temp_directions[key].order] = object
                    this.listDirections[this.temp_directions[key].order]['unused'] = false
                    this.temp_directions.splice(key, 1);
                }
            }
        },
        // Ставим индексы каждому направлению
        numerateListDirections() {
            let iterator = this.listDirections.keys();
            for (let key of iterator) {
                this.listDirections[key]['order'] = key;
            }
        },
    },
    async created() {
        // список общих направлений
        await this.getListDirections();
        // список личных направлений
        await this.getOwnDirections();
    },
    watch: {
        $route: {
            handler() {
                this.getFullData();
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
</style>
